import React from 'react'

export const Footer=({messages})=>{
    return (<div className='footer'>{messages.copyright.message}</div>)
}